/**
 * Weapon Charge — helper functions for the weapon progression resource.
 * Charge fills passively each turn and from dealing/taking damage.
 * When full, unlocks S2/S3 weapon tiers. Drains to 0 on fire.
 */

import { lookupTank } from '../tanks';
import type { Player } from '../types';

/** Check if the player's weapon charge is full (S2/S3 available). */
export function isChargeReady(player: Player): boolean {
  const chargeMax = lookupTank(player.tankId).chargeSize ?? 100;
  return player.weaponCharge >= chargeMax;
}

/** Get weapon charge fill as a 0..1 fraction. */
export function getChargeFraction(player: Player): number {
  const chargeMax = lookupTank(player.tankId).chargeSize ?? 100;
  return Math.max(0, Math.min(1, player.weaponCharge / chargeMax));
}

/** Drain weapon charge to 0 (called on S2/S3 fire). */
export function drainCharge(player: Player): void {
  player.weaponCharge = 0;
  player.chargeDrainedThisTurn = true;
}
